import {
    RrsTemplate,
    RrsTemplateLabel,
    RrsTemplateLevel,
    RrsTemplateRiskRank,
} from "server/models"
import { OrderType, StateType } from "client/utils"
import {
    RrsCategoryList,
    RrsCategoryChildParent,
    RrsCategoryFilters,
} from "client/store"
import { TableGroupedIds } from "client/components"

export interface RrsTemplateProps {
    templateId: number
}

export interface RrsTemplateList { [templateId: number]: RrsTemplate }
export interface RrsTemplateFilters {
    search?: string
}

export interface RrsTemplateLabelCategoryList { [labelId: number]: number[] }

export interface RrsTemplateLevelList { [levelId: number]: RrsTemplateLevel }
export interface RrsTemplateLevelByCategoryList {
    [categoryId: number]: {
        levelIds: number[]
        levelList: RrsTemplateLevelList
    }
}
export interface RrsTemplateLevelByLabelList { [labelId: number]: RrsTemplateLevelByCategoryList }

export interface RrsTemplateRiskRankList { [rankTextId: string]: RrsTemplateRiskRank }

export type RrsTemplateValidation = { [key in keyof RrsTemplate]?: string }
export type RrsTemplateLabelValidation = { [key in keyof RrsTemplateLabel]?: string }
export type RrsTemplateLevelValidation = { [key in keyof RrsTemplateLevel]?: string }
export type RrsTemplateRiskRankValidation = { [key in keyof RrsTemplateRiskRank]?: string }

export interface RrsTemplateState {
    baseRoute: string

    templateList: RrsTemplateList
    templateIds: readonly number[]
    templateEdit: RrsTemplate

    labelList: readonly RrsTemplateLabel[]
    labelCategoryList: RrsTemplateLabelCategoryList
    levelList: RrsTemplateLevelByLabelList
    riskRankList: RrsTemplateRiskRankList

    categories: {
        categoryList: RrsCategoryList
        categoryIds: readonly TableGroupedIds[]
        categoryChildParent: RrsCategoryChildParent
        filters: RrsCategoryFilters
        selected: readonly number[]
    }

    editLoadState: StateType

    sortColumn: keyof RrsTemplate
    sortOrder: OrderType
    filters: RrsTemplateFilters

    reloadList: boolean
    reloadEdit: boolean
}

export const RRS_TEMPLATE_BASE_ROUTE = "RRS_TEMPLATE_BASE_ROUTE"

export const RRS_TEMPLATE_LIST = "RRS_TEMPLATE_LIST"
export const RRS_TEMPLATE_IDS = "RRS_TEMPLATE_IDS"
export const RRS_TEMPLATE_EDIT = "RRS_TEMPLATE_EDIT"

export const RRS_TEMPLATE_LABEL_LIST = "RRS_TEMPLATE_LABEL_LIST"
export const RRS_TEMPLATE_LABEL_CATEGORY_LIST = "RRS_TEMPLATE_LABEL_CATEGORY_LIST"
export const RRS_TEMPLATE_LEVEL_LIST = "RRS_TEMPLATE_LEVEL_LIST"
export const RRS_TEMPLATE_LEVEL_LIST_BY_CATEGORY = "RRS_TEMPLATE_LEVEL_LIST_BY_CATEGORY"
export const RRS_TEMPLATE_RISK_RANK_LIST = "RRS_TEMPLATE_RISK_RANK_LIST"

export const RRS_TEMPLATE_CATEGORIES_CATEGORY_LIST = "RRS_TEMPLATE_CATEGORIES_CATEGORY_LIST"
export const RRS_TEMPLATE_CATEGORIES_CATEGORY_IDS = "RRS_TEMPLATE_CATEGORIES_CATEGORY_IDS"
export const RRS_TEMPLATE_CATEGORIES_CATEGORY_CHILD_PARENT = "RRS_TEMPLATE_CATEGORIES_CATEGORY_CHILD_PARENT"
export const RRS_TEMPLATE_CATEGORIES_FILTERS = "RRS_TEMPLATE_CATEGORIES_FILTERS"
export const RRS_TEMPLATE_CATEGORIES_SELECTED = "RRS_TEMPLATE_CATEGORIES_SELECTED"

export const RRS_TEMPLATE_EDIT_LOAD_STATE = "RRS_TEMPLATE_EDIT_LOAD_STATE"

export const RRS_TEMPLATE_SORT = "RRS_TEMPLATE_SORT"
export const RRS_TEMPLATE_FILTERS = "RRS_TEMPLATE_FILTERS"

export const RRS_TEMPLATE_RELOAD_LIST = "RRS_TEMPLATE_RELOAD_LIST"
export const RRS_TEMPLATE_RELOAD_EDIT = "RRS_TEMPLATE_RELOAD_EDIT"
